import { FunctionComponent, useContext, useMemo, useRef } from "react";
import { BoundaryContext } from "@pjs/core-ui";
import { BaseEditor } from "../base-editor/BaseEditor.component";
import { limitInstances } from "../behaviours/limit-instances/LimitInstances.function";
import { displayShortcuts } from "../behaviours/display-shortcuts/functions/DisplayShortcuts.function";
import { multiLineFactory } from "../editor-factories/MultiLineFactory.function";
import { compactToolbarPreset } from "../toolbar-items/presets/Compact";
import { compactMultiLineParser } from "../html-parsers/CompactMultiLineParser.const.";
import { CompactMultiLineEditorProps } from "./types/CompactMultiLineEditorProps";
import "../../styles/attached-editor.css";
import "../../styles/utilities.css";

export const CompactMultiLineEditor: FunctionComponent<CompactMultiLineEditorProps> = (props) => {
    const toolbarRef = useRef<HTMLDivElement>(null);
    const boundaryContext = useContext(BoundaryContext);

    const config = useMemo(() => {
        return {
            behaviours: [limitInstances, displayShortcuts],
            boundaryElement: boundaryContext.element,
            parser: compactMultiLineParser,
            placeholder: props.placeholder,
            pluginOverrides: { linker: { onLink: props.onLink } },
            toolbarItems: compactToolbarPreset
        };
    }, [boundaryContext.element, props.onLink, props.placeholder]);

    return (
        <div className="rt-attached-editor__container">
            <div data-hook="compact-editor-toolbar" className="util-sticky-editor-toolbar" ref={toolbarRef} />
            <BaseEditor
                ariaLabel={props.ariaLabel}
                ariaLabelledBy={props.ariaLabelledBy}
                autoFocus={props.autoFocus}
                className={`rt-attached-editor__text-area ${props.className ?? ""}`}
                content={props.content}
                config={config}
                dataHook={props.dataHook}
                factory={multiLineFactory}
                onChange={props.onChange}
                onToolbarDisplayChange={props.onToolbarDisplayChange}
                toolbarRef={toolbarRef}
            />
        </div>
    );
};
